import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function NewsTicker() {
  const [items, setItems] = useState([]);
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => {
      const arr = (r.data?.news_items || []).filter((x) => x && x.trim());
      setItems(arr);
      setEvent(r.data?.featured_event || null);
    }).catch(() => {});
  }, []);

  const eventLine = buildEventLine(event);
  if (items.length === 0 && !eventLine) return null;

  // Event nudge leads the ticker; duplicate so the marquee loops seamlessly
  const base = eventLine ? [eventLine, ...items.map((t) => ({ text: t }))] : items.map((t) => ({ text: t }));
  const loop = [...base, ...base];

  return (
    <div className="bg-orange-600 text-white border-b border-orange-700 overflow-hidden" data-testid="news-ticker">
      <div className="flex items-center">
        <div className="shrink-0 bg-black px-4 py-2 font-display tracking-[0.25em] text-xs uppercase border-r border-orange-700">
          ★ OSCR NEWS
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-12 whitespace-nowrap py-2 ticker-track">
            {loop.map((it, i) => (
              <span key={i} className="font-mono text-xs tracking-wider uppercase">
                {it.href ? (
                  <TickerLink href={it.href} external={it.external} testid={i === 0 ? "ticker-event-line" : undefined}>
                    {it.text}
                  </TickerLink>
                ) : it.text}
                <span className="text-black/50 ml-12">●</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function TickerLink({ href, external, testid, children }) {
  const cls = "font-bold underline decoration-black/40 underline-offset-2 hover:decoration-white transition";
  if (external) {
    return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls}>{children}</a>;
  }
  return <Link to={href} data-testid={testid} className={cls}>{children}</Link>;
}

/** "LATENT 5K IN 59 DAYS — REGISTER NOW" style nudge, computed in IST calendar days. */
function buildEventLine(ev) {
  if (!ev || !ev.enabled || !ev.title) return null;
  const external = /^https?:\/\//i.test(ev.register_url || "");
  const href = external ? ev.register_url : "/";
  const title = ev.title.toUpperCase();

  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((ev.date || "").trim());
  if (!m) return { text: `${title} — DATES ANNOUNCING SOON · STAY TUNED`, href, external };

  const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
  const nowIst = new Date(Date.now() + IST_OFFSET_MS);
  const todayUtc = Date.UTC(nowIst.getUTCFullYear(), nowIst.getUTCMonth(), nowIst.getUTCDate());
  const eventUtc = Date.UTC(+m[1], +m[2] - 1, +m[3]);
  const days = Math.round((eventUtc - todayUtc) / 86400000);

  if (days < 0) return null;
  if (days === 0) return { text: `${title} IS TODAY — SEE YOU AT THE START LINE`, href, external };
  if (days === 1) return { text: `${title} IS TOMORROW — LAST CHANCE TO REGISTER`, href, external };
  return { text: `${title} IN ${days} DAYS — REGISTER NOW`, href, external };
}
